<template>
    <div class="user_profile_wrap form_complete">
        <div class="title">My Profile</div>
        <form  @submit.prevent="submit_completeAccount()">
             <div class="row">
             <div class="col-md-12">
                <div class="center content-inputs wrapfields">
                      <div class="center content-inputs">
                       <vs-input v-model="email"  :placeholder="`${get_setting.name}@gmail.com`">
                        <template v-if="validEmail" #message-success>
                        Email Valid
                        </template>
                        <template v-if="!validEmail && email !== ''" #message-danger>
                        Email Invalid
                        </template>
                    </vs-input>
                        </div>
                    </div>
            </div>
            <div class="col-md-6">
                 <div class="center content-inputs wrapfields">
                      <div class="center content-inputs">
                        <vs-input  v-model="name" placeholder="Your Name" />
                        </div>
                    </div>
            </div>
            <div class="col-md-6">
                <div class="center content-inputs wrapfields">
                      <div class="center content-inputs">
                        <vs-input v-model="address" placeholder="Address" />
                        </div>
                    </div>
            </div>
            <div class="col-md-6">
                <div class="center content-inputs wrapfields">
                      <div class="center content-inputs">
                        <vs-input v-model="city" placeholder="City" />
                        </div>
                    </div>
            </div>
            <div class="col-md-6">
                <div class="center content-inputs wrapfields">
                      <div class="center content-inputs">
                        <vs-input v-model="postal_code" placeholder="Postal Code" />
                        </div>
                    </div>
            </div>
            <div class="col-12">
                 <vs-button
                type="submit"
                color="#343a40"
                gradient
                square
                :loading="loading_comp"
                :disabled="!validEmail || name=='' || email=='' || city=='' || address=='' || postal_code==''"
                >
                <span>Save</span>
                </vs-button>
            </div>
        </div>
        <!-- <b-button :disabled="false" :loading="loading" class="savebtn"  native-type="submit" type="is-success">{{get_setting.trans[41].name}}<ion-icon name="checkmark-done-circle-outline"></ion-icon></b-button> -->
        </form>
    </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex';

export default {
    name:'userprofile',
     data() {
        return {
             name:'',
        address:'',
        city:'',
        postal_code:'',
        email:'',
        loading_comp:false,
        }
    },
    computed:{
    ...mapGetters({
         user:'auth/user',
         get_setting:'get_setting'
    }),
    validEmail() {
            return /[a-zA-Z0-9.]*@[a-z]*[.a-z]*/.test(this.email);
        },
   },
   methods:{
       ...mapActions({
         complete_Account_api:'complete_Account_api'
       }),
        fill_data(){
        console.log(this.user)
        if(this.user.name !=null){
            this.name = this.user.name;
        }
         if(this.user.email !=null){
            this.email = this.user.email;
        }
         if(this.user.address !=null){
            this.address = this.user.address;
        }
         if(this.user.city !=null){
            this.city = this.user.city;
        }
         if(this.user.postal_code !=null){
            this.postal_code = this.user.postal_code;
        }
    },
    submit_completeAccount(){
        this.loading_comp = true;
        let userdata = {
        'name': this.name,
        'address':this.address,
        'city':this.city,
        'postal_code':this.postal_code,
        'email':this.email,
        }
        this.complete_Account_api(userdata).then(()=>{
            this.loading_comp = false;
            this.openNotification('bottom-right', 'success' , 'Save successfully' , 'Your data has been modified successfully');
        });
    },
    // Notifucation
      openNotification(position = null, color , title , text) {
      this.$vs.notification({
        color,
        position,
        title: title,
        text: text,
        //duration:'8000000'
      });
    },
   },
    mounted(){
    this.fill_data();
  }
}
</script>
<style lang="scss" >
.user_profile_wrap{
    form{
    background-color: transparent;
    position: relative;
    padding: 14px 0px 10px 0px;
    }
    .title{
    font-size: 30px;
    position: relative;
    display: inline-block;
    padding-top: 4px;
     font-family: "Oswald", sans-serif;
     font-weight: 500;
    color: var(--active_color) !important;
    border-bottom: 3px solid var(--active_color) !important;
    padding-bottom: 6px;
    margin-bottom: 10px !important;
    }
 
.field.is-floating-label .label:before{
     background-color: #525252 !important;
}

.field.is-floating-label .label:before{
     background-color: #333436 !important
}

.savebtn{
    font-weight: 600;
    span{
        display: flex;
        align-items: center;
        ion-icon{
        margin-left: 7px;
         font-size: 22px;
        }
    }
}
    form{
        max-width: 600px;
    }

 .mb-filed{
            margin-bottom: 20px !important; 
        }
}
 .form_complete{
        width: 80%;
        margin-left: auto;
        margin-right: auto;
    }
    h2{
        font-size: 1.8rem;
        font-weight: 500;
    }
    .wrapfields{
        margin-bottom: 20px;
    }
</style>